import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID, // Application (client) ID
    authority: process.env.REACT_APP_AUTHORITY, // Directory (tenant) ID
    // redirectUri: "https://telekom-iat-new.frontend.trinarybits.com/", // Your redirect URI,
    redirectUri: process.env.REACT_APP_REDIRECT_URI
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ['user.read'],
  prompt: 'select_account'
  // loginHint: "user@trinarybits.in" || "user@trinarybits.com" || "user@a1.at"
};

export const signupRequest = {
  scopes: ['user.read'],
  prompt: 'create' // This prompt forces the sign-up process
  // loginHint: "user@trinarybits.in" || "user@trinarybits.com" || "user@a1.at"
};
